import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'date_to_time_pipe'})
export class DateToTimePipe implements PipeTransform {
    public transform(date: Date): string {
        const timeStartIndex: number = 11;
        const timeLength: number = 5;

        const pipedTime: string = `${date.toISOString().substr(timeStartIndex, timeLength)} Uhr`;
        return pipedTime;
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pipes/pipe-date-to-time.ts